import { Box, Tabs, Tab, Card } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TabPanel from "../../../../TabPanel";
import ServiceDetailsTab from "./ServiceDetailsTab";
import InValuesTab from "./InValuesTab";
import OutValuesTab from "./OutValuesTab";

const WebServiceControls = ({
  disableControls,
  repoPDC,
  useConnection,
  handleBodyContent,
  screen,
}) => {
  const { t } = useTranslation();
  const [currTab, setCurrTab] = useState(0);

  const handleTabChange = (_event, newValue) => {
    setCurrTab(newValue);
  };

  return (
    // <div className="div-textbox" style={{ height: "auto" }}>
    <Card sx={{ mx: "auto", mt: 4, boxShadow: 5 }}>
      <Box height={"100%"}>
        <Box className="divider-bottom flex align-center">
          <Tabs
            value={currTab}
            onChange={handleTabChange}
            className="flex align-center"
          >
            <Tab
              label={
                <div className="flex align-center margin-right-4">
                  {t("SERVICE_")}
                </div>
              }
            />
            <Tab
              label={
                <div className="flex align-center margin-right-4">
                  {t("TAB_IN_VALUES")}
                </div>
              }
            />
            <Tab
              label={
                <div className="flex align-center margin-right-4">
                  {t("TAB_OUT_VALUES")}
                </div>
              }
            />
          </Tabs>
        </Box>
        <Box
          className="height-100-tab overflow-auto"
          sx={{ minHeight: "25vh", overflowY: "auto" }}
        >
          <TabPanel style={{ minWidth: "150px" }} value={currTab} index={0}>
            {currTab === 0 && (
              <ServiceDetailsTab
                disableControls={disableControls}
                repoPDC={repoPDC}
                useConnection={useConnection}
                submitServiceDetails={handleBodyContent}
                screen={screen}
              />
            )}
          </TabPanel>
          <TabPanel style={{ minWidth: "150px" }} value={currTab} index={1}>
            {currTab === 1 && (
              <InValuesTab
                submitServiceDetails={handleBodyContent}
                screen={screen}
              />
            )}
          </TabPanel>
          <TabPanel style={{ minWidth: "150px" }} value={currTab} index={2}>
            {currTab === 2 && (
              <OutValuesTab
                submitServiceDetails={handleBodyContent}
                screen={screen}
              />
            )}
          </TabPanel>
        </Box>
      </Box>
    </Card>
    /* </div> */
  );
};

export default WebServiceControls;
